import { Box, Container } from "@sembark-travel/ui-base"
import {
	Breadcrumbs,
	useGetBackUrlFromLocation,
} from "@sembark-travel/ui-router"
import { generatePath } from "../../../../router-utils"
import { Helmet } from "react-helmet-async"
import { useNavigate } from "react-router"
import { ForbidUnlessAuthorized, PERMISSIONS } from "../../../../Auth"
import { TagForm } from "../../../../Tags"

export default function NewTripTagPage() {
	const navigate = useNavigate()
	const backFromUrl = useGetBackUrlFromLocation()
	const listingPage = generatePath("/org/tags/trips")
	function navigateBackOrToList() {
		if (backFromUrl) {
			return navigate(backFromUrl as "/org/tags/trips")
		}
		return navigate("/org/tags/trips")
	}

	return (
		<>
			<Helmet>
				<title>Add Trip Tag</title>
			</Helmet>
			<ForbidUnlessAuthorized permission={PERMISSIONS.MANAGE_TAGS}>
				<Breadcrumbs
					title="New Tag"
					items={[
						[listingPage, "Tags"],
						[listingPage, "Trip"],
						["", "New"],
					]}
				/>

				<Box paddingX={{ md: "4" }} paddingY={{ md: "8" }}>
					<Box maxWidth="4xl" marginX="auto">
						<Box borderWidth={{ md: "1" }} rounded="md" bgColor="default">
							<Container paddingY="6">
								<TagForm
									scope="trips"
									onSuccess={navigateBackOrToList}
									onCancel={navigateBackOrToList}
								/>
							</Container>
						</Box>
					</Box>
				</Box>
			</ForbidUnlessAuthorized>
		</>
	)
}
